import { z } from 'zod';
import { objectIdSchema } from './objectId';
import { DaySchema, TimeSchema } from './time';
import { AudienceSchema } from './audience';
import { MergedVariablesSchema } from './mergedVars';
import { McmSchema } from './mcm';
import { BareContentTemplateSchema } from './contentTemplate';
import { DailyProgramCtaSchema } from './dailyProgramCta';

export const BareContentSchema = z.object({
  id: objectIdSchema,
  template: z.string(),
  day: z.string(),
  startTime: TimeSchema,
  duration: z.number(),
  callToActions: z.array(DailyProgramCtaSchema),
  venue: z.string().optional(),
  venueDisplayName: z.string().optional(),
  deckDisplayName: z.string().optional(),
  templateSourceId: z.string().optional(),
  mergedVars: MergedVariablesSchema.optional(),
  mcm: McmSchema.optional(),
  audience: AudienceSchema.optional(),
});

export const ContentSchema = z.object({
  id: objectIdSchema,
  template: BareContentTemplateSchema,
  day: DaySchema,
  startTime: TimeSchema,
  callToActions: z.array(DailyProgramCtaSchema),
  venue: z.string().optional(),
  venueDisplayName: z.string().optional(),
  deckDisplayName: z.string().optional(),
  templateSourceId: z.string().optional(),
  mergedVars: MergedVariablesSchema.optional(),
  mcm: McmSchema.optional(),
  audience: AudienceSchema.optional(),
});
